function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vessel-Profile",
  transform: "translate(-1240.000000, -117.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "zoom",
  transform: "translate(1226.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22,119.320312 C21.7656238,119.13802 20.7044365,118.311205 18.8164062,116.839844 C16.928376,115.368482 15.4895883,114.255212 14.5,113.5 L22,107.679688 L29.5,113.5 C28.5104117,114.255212 27.0781344,115.361972 25.203125,116.820312 C23.3281156,118.278653 22.260418,119.111978 22,119.320312 Z M22,121.46875 L28.1328125,116.664062 L29.5,117.71875 L22,123.539062 L14.5,117.71875 L15.8671875,116.664062 L22,121.46875 Z",
  id: "layers"
}))));

var SvgLayers = function SvgLayers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLayers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/layers.03e38318.svg";
export { ForwardRef as ReactComponent };